import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import TextField from "@material-ui/core/TextField";


const MuiTextField = React.forwardRef((props: any, ref: any) => {
  const { label, name, required, errorobj } = props;

  let isError = false;
  let errorMessage = "";
  if (errorobj && errorobj.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errorobj[name].message;
  }
  return (
    <TextField
      id={name}
      label={label}
      variant="standard"
      error={isError}
      helperText={errorMessage}
      fullWidth={true}
      InputLabelProps={{
        className: required ? "required-label" : "",
        required: required || false,
      }}
      {...props}
    />
  );
});

function FormInput(props: any) {
  const { control } = useFormContext();
  const { name, required } = props;

  return (
    <Controller
      render={({ field }) => <MuiTextField {...field} {...props} />}
      name={name}
      control={control}
      rules={{ required: required || false }}
      defaultValue=""
    />
  );
}

export default FormInput;
